export default {
    parts: [],
    baseStyle: (props) => ({
        lgContainer: {
            position: 'relative',
            maxWidth: { lg: 'container.xxxl' },
            margin: '0 auto'
        },
        notFullBleed: {
            paddingLeft: { base: 4, lg: 0 },
            paddingRight: { base: 4, lg: 0 },
            maxWidth: { lg: 'container.xxxl' },
            margin: '0 auto'
        },
        HeroSize: {
            ...(props?.HeroSize === 'small' && {
                aspectRatio: {base: '375/200', md: '1440/300' }
            }),
            ...(props?.HeroSize === 'large' && {
                aspectRatio: {base: '375/585', md: '1440/570' }
            }),
            ...(props?.HeroSize === 'full' && {
                aspectRatio: {base: '375/585', md: '1440/810' }
            })
        },
        tooltip: {
            fontSize: 'xs',
            lineHeight: '15px',
            backgroundColor: 'white',
            color: 'black',
            padding: '4px 8px',
            borderRadius: 'unset',
            border: '1px solid grey.400',
            maxWidth: '220px'
        },
        tooltipIcon: {
            position: 'absolute',
            top: {base: '8px', lg: '24px'},
            right: {base: '8px', lg: '24px'},
            backgroundColor: 'unset',
            width: 'auto',
            height: 'auto',
            minHeight: 'auto',
            minWidth: 'auto',
            zIndex: 1,
            _hover: {
                backgroundColor: 'unset'
            }
        },
        overlay: {
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: 'black',
            opacity: '0.4',
            zIndex: '1'
        }
    })
}
